export default {
  app: 'APP_VIGIRA',
  api: '/portal'
};
